/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePasswordInput
 */
export interface ChangePasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    $type?: ChangePasswordInputTypeEnum;
}


/**
 * @export
 */
export const ChangePasswordInputTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationAccountDtoChangePasswordInputPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Account.Dto.ChangePasswordInput, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ChangePasswordInputTypeEnum = typeof ChangePasswordInputTypeEnum[keyof typeof ChangePasswordInputTypeEnum];



/**
 * Check if a given object implements the ChangePasswordInput interface.
 */
export function instanceOfChangePasswordInput(value?: unknown): value is ChangePasswordInput {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ChangePasswordInputTypeEnum)[0];
}

export function ChangePasswordInputFromJSON(json: any): ChangePasswordInput {
    return ChangePasswordInputFromJSONTyped(json, false);
}

export function ChangePasswordInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePasswordInput {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPassword': json['currentPassword'],
        'newPassword': json['newPassword'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ChangePasswordInputToJSON(value?: ChangePasswordInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'currentPassword': value['currentPassword'],
        'newPassword': value['newPassword'],
        '$type': value['$type'],
    });
}

